export enum SpecialistGroupType {
  TELE = 'tele',
}

/** Which specialist group members get the "New eConsult assigned" email. */
export enum AssignmentNotificationMode {
  EveryAssignment = 'EveryAssignment',
  Standard = 'Standard',
  Off = 'Off',
}
